// removed by extract-text-webpack-plugin
module.exports = {"box":"_974fc64daf_src-projects-_ArchiveOrUnarchiveProjectModal_box","bottom":"c58f8f019d_src-projects-_ArchiveOrUnarchiveProjectModal_bottom","warningMessage":"db8edb1f02_src-projects-_ArchiveOrUnarchiveProjectModal_warningMessage","error":"_044dd40edc_src-projects-_ArchiveOrUnarchiveProjectModal_error","dropZone":"_4033ab8e90_src-projects-_ArchiveOrUnarchiveProjectModal_dropZone","dropZoneActive":"_55614bc831_src-projects-_ArchiveOrUnarchiveProjectModal_dropZoneActive"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/ArchiveOrUnarchiveProjectModal.css
// module id = 1704
// module chunks = 0